export var SortOption;
(function (SortOption) {
    SortOption["Date"] = "date";
    SortOption["Owner"] = "owner";
    SortOption["Name"] = "name";
})(SortOption || (SortOption = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "ascending";
    SortOrder["Descending"] = "descending";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=SortOption.js.map